import React from 'react'
import { Logo } from 'modules/ui/atoms/Logo'
import { ActionButton } from 'modules/ui/atoms/ActionButton'
import { usePaymentMethodSelection } from '../hooks/use-payment-method-selection'
import { translate } from '../../../../../utils/functions/translate'
import { PaymentMethodConfig } from '../utils/payment-method-configs'
import useConfig from 'modules/config/state/use-config'
import LoadingSpinnerComponent from 'modules/ui/atoms/Loading/LoadingSpinner'
import { selectContrastingColor } from '@classy/campaign-page-blocks'

interface PaymentMethodActionButtonProps {
  dataIdPrefix?: string
}

export const PaymentMethodActionButton = ({
  dataIdPrefix = 'payment-method-continue-button',
}: PaymentMethodActionButtonProps) => {
  const config = useConfig()

  const { selectedPaymentMethod, selectedPaymentMethodConfig, isLoading } =
    usePaymentMethodSelection()

  // Show loading state when payment methods are still loading
  if (isLoading) {
    const buttonColor = config.theme['--theme-color__brand-primary']

    return (
      <ActionButton disabled color={buttonColor} size="lg" borderRadius="12px">
        <LoadingSpinnerComponent size="sm" color={selectContrastingColor(buttonColor)} />
      </ActionButton>
    )
  }

  return !!selectedPaymentMethodConfig?.actionButton ? (
    <_PaymentButton
      paymentMethodConfig={selectedPaymentMethodConfig}
      dataId={`${dataIdPrefix}-${selectedPaymentMethod.toLowerCase()}`}
    />
  ) : null
}

const _PaymentButton = ({
  paymentMethodConfig,
  dataId,
}: {
  paymentMethodConfig: PaymentMethodConfig
  dataId: string
}) => {
  // Get the dynamic action button component from the config
  const ActionButton = paymentMethodConfig?.actionButton

  // Default footer labels for different payment methods
  const PaymentMethodFooterLabels: { [key: string]: string } = {
    card: translate('DonorInformationStep.footerButton.donateMessage.now', 'Continue'),
    bank_transfer: translate('DonorInformationStep.footerButton.donateMessage.now', 'Continue'),
  }

  return ActionButton ? (
    <ActionButton dataId={dataId} paymentMethodConfig={paymentMethodConfig}>
      {!paymentMethodConfig.actionButtonText && paymentMethodConfig.labelKey
        ? PaymentMethodFooterLabels[paymentMethodConfig.labelKey]
        : paymentMethodConfig.actionButtonText}
      {paymentMethodConfig?.actionButtonLogo && (
        <Logo
          name={paymentMethodConfig?.actionButtonLogo}
          altText={paymentMethodConfig?.actionButtonLogoAltText}
        />
      )}
    </ActionButton>
  ) : null
}
